document
	.querySelectorAll('.wp-block-metawood-slider .swiper')
	.forEach((swiperEl) => {
		const settings = JSON.parse(swiperEl.dataset.settings || '{}');

		if (settings.pagination !== false) {
			settings.pagination = {
				...settings.pagination,
				renderFraction: function (currentClass, totalClass) {
					return (
						'<span class="' +
						currentClass +
						'"></span>' +
						'/' +
						'<span class="' +
						totalClass +
						'"></span>'
					);
				},
			};
		}

		// Init Swiper
		const swiper = new Swiper(swiperEl, settings);

		// Pause autoplay until visible
		if (swiper.autoplay) {
			swiper.autoplay.stop();
		}

		// Intersection Observer to start autoplay the first time it's visible
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						if (swiper.autoplay) swiper.autoplay.start();
						observer.unobserve(swiperEl);
					}
				});
			},
			{
				threshold: 0.25,
			}
		);

		observer.observe(swiperEl);
	});
